import type { MenuProduct } from "@/mocks/branch/menu";

interface ProductCardProps {
  product: MenuProduct;
  onAdd: (product: MenuProduct) => void;
}

export default function ProductCard({ product, onAdd }: ProductCardProps) {
  const unavailable = product.available === false || product.quantity === 0;
  const lowStock =
    product.quantity !== null && product.quantity > 0 && product.quantity <= 5;

  const handleAdd = () => {
    if (unavailable) return;
    onAdd(product);
  };

  return (
    <div
      onClick={handleAdd}
      className={`relative bg-background-50 rounded-card border border-background-200 overflow-hidden flex flex-col transition-all duration-200 ${
        unavailable
          ? "opacity-60 cursor-not-allowed"
          : "hover:border-primary-300 cursor-pointer"
      }`}
    >
      <div className="relative w-full h-28 shrink-0">
        <img
          src={product.image}
          alt={product.name}
          title={`${product.name} — Your Cashier`}
          className="w-full h-full object-cover object-top"
        />
        {unavailable ? (
          <div className="absolute inset-0 bg-foreground-900/60 flex items-center justify-center">
            <span className="px-2.5 py-1 rounded-full bg-foreground-900 text-white text-xs font-bold whitespace-nowrap">
              غير متوفر
            </span>
          </div>
        ) : null}
        {lowStock ? (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-red-500 text-white text-[11px] font-bold whitespace-nowrap">
            باقي {product.quantity}
          </span>
        ) : null}
      </div>

      <div className="p-2.5 flex-1 flex flex-col">
        <p className="text-sm font-semibold text-foreground-900 leading-tight truncate">
          {product.name}
        </p>
        <p className="mt-1 text-sm font-bold text-primary-600">
          {product.price.toFixed(2)} ر.س
        </p>
        <button
          type="button"
          disabled={unavailable}
          onClick={(e) => {
            e.stopPropagation();
            handleAdd();
          }}
          className="mt-2 h-10 rounded-btn bg-primary-500 text-white text-sm font-bold flex items-center justify-center gap-1 hover:bg-primary-600 disabled:bg-background-200 disabled:text-foreground-400 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-add-line text-lg"></i>
          إضافة
        </button>
      </div>
    </div>
  );
}